import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { EvaluationInterface } from 'app/assessment/evaluation/models';
import { BrowserService } from 'app/core/browser/services/browser.service';
import { DashboardAccordionIndexEnum } from 'app/my-zone/home/constants/dashboard-accordion-index.enum';
import { DashboardTabIndexEnum } from 'app/my-zone/home/constants/dashboard-tab-index.enum';
import { TaskInterface } from 'app/task/models';
import { TaskService } from 'app/task/services';

@Component({
  selector: 'cz-ergo-eval-complete-evaluation-dialog',
  templateUrl: './ergo-eval-complete-evaluation-dialog.component.html',
  styleUrls: ['./ergo-eval-complete-evaluation-dialog.component.scss'],
})
export class ErgoEvalCompleteEvaluationDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { evaluation: EvaluationInterface, task: TaskInterface },
              private readonly _taskService: TaskService,
              private readonly _browserService: BrowserService) { }

  public ngOnInit(): void {
  }

  public completeEvaluation(): void {
    this._taskService.close(this.data.task);
    this._browserService.toDashboard(DashboardTabIndexEnum.tasks, DashboardAccordionIndexEnum.completed);
  }

}
